<template>
  <div v-loading="loading">
    <register-tearm-components
      v-if="!loading"
      :line-color="'transparent'"
      :disabled-falg="disabledFalg"
      :form="form"
      @back="back"
      :field-name-options="fieldNameOptions"
      :dict-data-list="dictDataList"
      :site-id="this.siteId"
      :field-map="fieldMap"
      @worktype="worktype"
      :key="componentKey"
    >
    </register-tearm-components>
  </div>
</template>

<script>
import RegisterComponents from './form/registerComponents'
import {
  conditionByParticipantData,
  listBySiteIdSelectTearm,
  selectBySiteid
} from '../../api/registerForm'
import RegisterTearmComponents from './form/registerTearmComponents'
export default {
  name: 'registerForm',
  components: { RegisterTearmComponents, RegisterComponents },
  props: ['singUpId'],
  data () {
    return {
      fieldNameOptions: [],
      form: {
        status: '1'
      },
      disabledFalg: false,
      formLoading: true,
      dictDataList: [],
      fieldMap: {},
      // 遮罩层
      loading: true,
      // 队员信息是否隐藏
      memberShow: 0,
      componentKey: 0
    }
  },
  mounted () {
    if (this.$route.query.workType) {
      this.memberShow = this.$route.query.workType
    }
  },
  created () {
    // 获取当前用户已报名的类型传递到下个页面进行队员显示
    conditionByParticipantData(this.baseURL, {
      siteId: this.siteId,
      status: '1',
      userId: this.$store.state.user.userId,
      id: this.$route.query.id
    }).then((res) => {
      if (res.data.length >= 1) {
        this.getForm(res.data[0].competitionProject)
      } else {
        this.getForm()
      }
    })
  },
  methods: {
    back (val) {
      this.getForm()
    },
    worktype (val) {
      this.getForm(val)
    },
    formLoadingStatus (falg) {
      this.formLoading = falg
    },
    getForm (val) {
      if (this.$route.query.workType) {
        val = this.$route.query.workType
      }
      let that = this
      if (val === '2' || val === 2) {
        this.memberShow = '0'
      } else if (val === '3' || val === 3) {
        this.memberShow = '1'
      } else if (val === '1' || val === 1) {
        this.memberShow = '2'
      }
      console.log('val :' + val)
      console.log('val :' + typeof val)
      listBySiteIdSelectTearm(this.baseURL, {
        siteId: this.siteId,
        status: 1,
        dynamicDisplay: this.memberShow
      }).then((res) => {
        this.fieldMap = res.data.fieldMap
        this.dictDataList = res.data.dictDataList
        this.fieldNameOptions = res.data.fieldNameOptions
        this.componentKey += 1
        if (this.fieldNameOptions.length === 0) {
          this.$message({
            message: '大赛尚未开放报名',
            type: 'info',
            duration: 1000
          })
        }
        conditionByParticipantData(this.baseURL, {
          siteId: this.siteId,
          status: '1',
          userId: this.$store.state.user.userId,
          competitionProject: val,
          id: this.singUpId
        }).then((res) => {
          if (res.data.length >= 1) {
            that.form = res.data[0]
            let copyForm = { ...res.data[0] }
            that.form = JSON.parse(res.data[0].data)
            that.form.siteId = copyForm.siteId
            that.form.userId = copyForm.userId
            that.form.id = copyForm.id
            that.form.status = '1'
          }
          this.loading = false
        })
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/my/registerForm.vue